import { normalizeValue } from '@dte/otw-utils-core/src/strings/normalizeValue';

export function normalizePath(value: string | undefined): string | undefined {
	let normalized = normalizeValue(value);

	// Remove trailing slash
	if (normalized?.endsWith('/')) {
		normalized = normalized.slice(0, -1);
	}

	return normalized;
}
